import Image from 'next/image';
import Slider from 'rc-slider';
import { useEffect, useState } from 'react';
import {
  useClearRefinements,
  useNumericMenu,
  useRange,
  useToggleRefinement
} from 'react-instantsearch';

import { staticMediaStoreBaseURL } from '@/config/common';
import DISCOUNT_ITEMS from '@/config/searchFilters';

const DesktopSideBarFilters = ({ priceRange }) => {
  const [showDiscountFilter, setShowDiscountFilter] = useState(true);

  const { value: instantPriceValue, refine: refineInstantPrice } =
    useToggleRefinement({ attribute: 'isInstantPrice', on: true });

  const {
    range,
    start,
    refine: refinePrice,
    canRefine: canRefinePrice
  } = useRange({ attribute: 'price.sortPrice' });

  const { items: discountOptions, refine: refineDiscount } = useNumericMenu({
    attribute: 'discount',
    items: DISCOUNT_ITEMS
  });

  const { refine: clearDiscountFilter } = useClearRefinements({
    includedAttributes: ['discount']
  });

  const [currentMin, currentMax] = start;
  const committedMin = Number.isFinite(currentMin)
    ? currentMin
    : (range.min ?? 0);
  const committedMax = Number.isFinite(currentMax)
    ? currentMax
    : (range.max ?? 0);

  const [sliderValue, setSliderValue] = useState([committedMin, committedMax]);
  const [displayMin, displayMax] = sliderValue;

  useEffect(() => {
    setSliderValue([committedMin, committedMax]);
  }, [committedMin, committedMax]);

  const showPriceSlider =
    (canRefinePrice || Number.isFinite(currentMin)) &&
    (priceRange?.max_price?.value > 0 || (range.max && range.max > 0));

  return (
    <div className='h-90vh overflow-y-scroll no-scrollbar pb-24'>
      <div
        id='Price'
        className='border-t border-gray block'
      >
        <div>
          <div className='cursor-pointer py-4 pb-11px'>
            <span className='text-lg text-nero capitalize block leading-5 font-medium select-none'>
              Price
            </span>
          </div>
          <ul id='instantprice'>
            <li className='flex justify-start items-center pb-11px'>
              <label>
                <div className='flex items-center'>
                  <input
                    checked={instantPriceValue.isRefined}
                    className='rounded-sm box-border text-nero focus:border-nero focus:ring-nero w-4 h-4'
                    name='Instant Price Products'
                    onChange={() => refineInstantPrice(instantPriceValue)}
                    type='checkbox'
                  />
                  <div className='text-nero font-normal text-sm leading-17px capitalize ml-3'>
                    Instant Price Products Only
                  </div>
                </div>
              </label>
            </li>
          </ul>
          {showPriceSlider && (
            <div className='custom-slider max-w-50 md:max-w-58 relative mb-7 ms-4.5'>
              <div className='text-xs text-nero block font-normal leading-4 pb-2 select-none -ml-4'>
                Selected price range
              </div>
              <div className='text-sm text-nero block font-semibold leading-4 pb-6 select-none -ml-4'>
                AED {displayMin} - AED {displayMax}
              </div>
              <Slider
                range
                min={range.min ?? 0}
                max={range.max ?? 0}
                value={[displayMin, displayMax]}
                onChange={(value) => setSliderValue(value)}
                onChangeComplete={(value) => refinePrice(value)}
                allowCross={false}
              />
            </div>
          )}
        </div>
        <div
          id='discount-box'
          className='border-t border-gray'
        >
          <div
            className='flex items-center justify-between cursor-pointer py-4'
            onClick={() => setShowDiscountFilter((prev) => !prev)}
          >
            <span className='text-lg text-nero capitalize block leading-5 font-medium select-none'>
              Discount
            </span>
            <div className='pe-4'>
              <Image
                src={`${staticMediaStoreBaseURL}/icons/down-arrow.svg`}
                width={12}
                height={12}
                priority={true}
                alt='down arrow'
              />
            </div>
          </div>
          {discountOptions.map((item) => (
            <label
              className={`flex items-center mb-3 cursor-pointer ${
                !showDiscountFilter ? 'hidden' : ''
              }`}
              key={item.value}
              onClick={(e) => {
                e.preventDefault();
                if (item.isRefined) {
                  clearDiscountFilter();
                } else {
                  refineDiscount(item.value);
                }
              }}
            >
              <input
                type='radio'
                name='discount'
                checked={item.isRefined}
                readOnly
                className='rounded box-border border-gray border-1 text-nero focus:border-nero focus:ring-nero w-4 h-4'
              />
              <span className='ms-3 text-nero font-normal font-Montserrat text-sm leading-17px select-none'>
                {item.label}
              </span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DesktopSideBarFilters;
